<template>
  <div class="p-5">
    <h5> محدودیت ها</h5>
    <div class="d-flex mt-5">
      <select v-model="activeConstraint.userId1">
        <option disabled value="">انتخاب دانش آموز</option>
        <option v-for="student in students" :value="student.id" v-text="student.name"></option>
      </select>
      <select v-model="activeConstraint.userId2">
        <option disabled value="">انتخاب دانش آموز</option>
        <option v-for="student in students" :value="student.id" v-text="student.name"></option>
      </select>
      <select v-model="activeConstraint.constraintType">
        <option value="TOGETHER">باید با هم باشند</option>
        <option value="NOTTOGETHER">نباید با هم باشند</option>
      </select>

      <feather-icon @click="createConstraint" class="cursor-pointer text-success" icon="PlusSquareIcon"
                    svgClasses="w-10 h-10 hover:stroke-current"/>
    </div>
    <div v-if="constraints.length" class="mt-5">
      <vs-table noDataText="موردی اضافه نشده" stripe :data="constraints">


        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="tr.userId1">
              <div class="d-flex align-items-center">
                <img height="30" width="30" class="round mr-3 img-fluid"
                     :src="findUser(tr.userId1).image || require('@/assets/images/avatar.png')">
                {{findUser(tr.userId1).name}}
              </div>
            </vs-td>
            <vs-td :data="tr.type">

              <feather-icon v-if="tr.type==='TOGETHER'" class="text-success" icon="UserCheckIcon" svgClasses="w-5 h-5"/>
              <feather-icon v-else icon="UserXIcon" class="text-danger" svgClasses="w-5 h-5"/>

            </vs-td>
            <vs-td :data="tr.userId2">
              <div class="d-flex align-items-center">
                <img height="30" width="30" class="round mr-3 img-fluid"
                     :src="findUser(tr.userId2).image || require('@/assets/images/avatar.png')">
                {{findUser(tr.userId2).name}}
              </div>
            </vs-td>
            <vs-td class="whitespace-no-wrap">
              <feather-icon class="cursor-pointer" @click="deleteConstraint(tr)" icon="TrashIcon"
                            svgClasses="w-5 h-5 hover:text-danger stroke-current"/>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

    </div>

  </div>
</template>

<script>
  export default {
    name: "Constraints",
    data() {
      return {
        activeConstraint: {
          taskId: this.taskId,
          userId1: '',
          userId2: '',
          constraintType: 'TOGETHER',
        }
      }
    },
    methods: {
      createConstraint() {
        if (!this.activeConstraint.userId1 || !this.activeConstraint.userId2 || this.activeConstraint.userId1 === this.activeConstraint.userId2) {
          alert('فیلد ها را با دقت پر کنید')
          return
        }

        let consExist = this.constraints.find(i => {
          return i.userId1 === this.activeConstraint.userId1 && i.userId2 === this.activeConstraint.userId2
        })
        if (consExist) {
          alert('برای این کاربران قبلا محدودیت اعمال شده')
          return
        }

        this.$store.dispatch('createConstraint', this.activeConstraint)
      },
      deleteConstraint(cons) {
        this.$store.dispatch('deleteConstraint', {
          taskId: cons.taskId,
          constraintType: cons.type,
          userId1: cons.userId1,
          userId2: cons.userId2,
        })
      },
      findUser(id) {
        let student = this.students.find(i => i.id === id);
        if (student) {
          return {
            name: student.name,
            image: student.image
          }
        }
        return {
          name: '',
          image: ''
        }
      }
    },
    computed: {
      constraints() {
        return this.$store.state.task.constraints
      },
      students() {
        return this.$store.state.task.members.map(i=>{
          return {
            id: i.id,
            name : i.firstName + ' ' + i.lastName,
            image: i.imagePath==='http://95.217.74.234/photo/null'?'':i.imagePath
          }
        });
      }
    },
    props: {
      taskId: [Number],
    }
  }
</script>

<style scoped>
  select {
    height: 43px;
    width: 28%;
    margin-right: 2%;
    border-radius: 4px;
    border: 1px solid #dcdcdc;
  }
</style>
